import { Box, IconButton, Link, Typography, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import { ExoMatchingProp } from '../../../components/exo/ExoMatchingProp';
import { useTranslation } from 'react-i18next';
import ExoAvatar from '../../../components/exo/ExoAvatar';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import { NavLink } from 'react-router-dom';

export const SalesObjectParameterTab = ({
  properties,
  inEditMode,
  onPropChange,
  setApiData,
  salesObjectId,
  supervisor,
  owner,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  function handleSelectionChange(newProps) {
    setApiData((prev) => {
      return { ...prev, data: { ...prev.data, properties: newProps } };
    });
  }

  const isNotCompany = !Boolean(owner?.name);
  const ownerName = !isNotCompany
    ? owner?.nameShort || owner?.name
    : `${owner?.firstName} ${owner?.lastName}`;

  return (
    <Box className="px-3 py-2 rounded-lg w-full">
      <Typography variant="h5" fontWeight={600} className="pb-3">
        {t('Properties')}
      </Typography>
      <ExoMatchingProp
        properties={properties}
        objectProperties={properties}
        isEditMode={inEditMode}
        onChange={onPropChange}
        onSalesObjectChange={setApiData}
        onSelectionChange={handleSelectionChange}
        salesObjectId={salesObjectId}
        className="grid lg:grid-cols-2 gap-x-9 gap-y-2"
        addLabel={t('add property')}
      />
      <Box
        className=" px-4 py-3 mt-10 rounded-lg grid lg:grid-cols-2 gap-4"
        sx={{ bgcolor: colors.card }}
      >
        <Box>
          <Typography variant="h6" className="pb-2">
            {t('Object supervisor')}
          </Typography>
          <Box className="flex gap-4">
            <Box className="flex flex-col">
              <Typography variant="h4" className="flex items-center gap-2 pb-1">
                <ExoAvatar
                  picture={
                    supervisor.picture && supervisor.picture.temporaryUrl
                  }
                  name={`${supervisor.firstName} ${supervisor.lastName}`}
                  size="30px"
                />
                {`${supervisor.salutation} ${supervisor.firstName} ${supervisor.lastName}`}
              </Typography>

              <Box className="flex items-center gap-1">
                <Link href={`tel:${supervisor.phone}`}>
                  <IconButton size="small">
                    <LocalPhoneIcon />
                  </IconButton>
                </Link>
                <Typography>{supervisor.phone}</Typography>
              </Box>

              <Box className="flex items-center gap-1">
                <Link href={`mailto:${supervisor.email}`}>
                  <IconButton size="small">
                    <EmailIcon />
                  </IconButton>
                </Link>
                <Typography>{supervisor.email}</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        {owner && (
          <Box>
            <Typography variant="h6" className="pb-2">
              {t('Owner')}
            </Typography>
            <Box className="flex gap-4">
              <NavLink
                to={
                  !isNotCompany
                    ? `/companies/${owner?.id}`
                    : `/contacts/${owner?.id}`
                }
              >
                <Box className="flex flex-col">
                  <Typography
                    variant="h4"
                    className="flex items-center gap-2 pb-1"
                  >
                    <ExoAvatar
                      picture={owner?.logo && owner?.logo?.temporaryUrl}
                      name={ownerName}
                      size="30px"
                    />
                    {`${!isNotCompany ? '' : owner?.salutation} ${ownerName}`}
                  </Typography>
                </Box>
              </NavLink>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};
